import { IState } from 'types/redux'

export const getGlobalLoader = ({ global }: IState): boolean => global.isGlobalLoading

export const getToast = ({ global }: IState): any => global.toast
